import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=0dcff500&"
import script from "./screen.vue?vue&type=script&lang=js&"
export * from "./screen.vue?vue&type=script&lang=js&"
import style0 from "./screen.vue?vue&type=style&index=0&id=0dcff500&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports